import React, { useState } from 'react';
import { signIn, signUp, confirmSignUp } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';

const Login = ({ setUser }) => {
  const [isSignIn, setIsSignIn] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [showVerification, setShowVerification] = useState(false);
  const [userToConfirm, setUserToConfirm] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      if (isSignIn) {
        // Sign in
        const { isSignedIn, nextStep } = await signIn({
          username: email,
          password,
        });
        
        if (isSignedIn) {
          setUser({ username: email });
          navigate('/files');
        } else if (nextStep.signInStep === 'CONFIRM_SIGN_UP') {
          // User needs to confirm signup
          setShowVerification(true);
          setUserToConfirm(email);
          setError('Please confirm your account with the verification code sent to your email.');
        }
      } else {
        // Sign up
        if (password !== confirmPassword) {
          setError('Passwords do not match');
          return;
        }
        
        const { isSignUpComplete, userId, nextStep } = await signUp({
          username: email,
          password,
          options: {
            userAttributes: {
              email,
            },
            autoSignIn: false,
          },
        });
        
        setShowVerification(true);
        setUserToConfirm(email);
        setError('Sign up successful! Please enter the verification code sent to your email.');
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const handleVerification = async (e) => {
    e.preventDefault();
    setError('');

    try {
      await confirmSignUp({
        username: userToConfirm,
        confirmationCode: verificationCode,
      });

      setError('Account verified successfully! Please sign in.');
      setShowVerification(false);
      setIsSignIn(true);
    } catch (error) {
      setError(error.message);
    }
  };

  if (showVerification) {
    return (
      <div className="auth-container">
        <h2>Verify Your Account</h2>
        {error && <p className="error">{error}</p>}
        <form onSubmit={handleVerification}>
          <div className="form-group">
            <label htmlFor="verificationCode">Verification Code</label>
            <input
              type="text"
              id="verificationCode"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              required
            />
          </div>
          <button type="submit">Verify</button>
        </form>
        <p>
          <button onClick={() => setShowVerification(false)}>
            Back to Sign In
          </button>
        </p>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <h2>{isSignIn ? 'Sign In' : 'Sign Up'}</h2>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {!isSignIn && (
          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>
        )}
        <button type="submit">{isSignIn ? 'Sign In' : 'Sign Up'}</button>
      </form>
      <p>
        {isSignIn ? "Don't have an account? " : "Already have an account? "}
        <button onClick={() => setIsSignIn(!isSignIn)}>
          {isSignIn ? 'Sign Up' : 'Sign In'}
        </button>
      </p>
    </div>
  );
};

export default Login;
